import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function VideoChat({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (
    <Icon
      data-icon={'videoChat'}
      viewBox='0 0 32 32'
      width={size}
      height={size} {...props}>

      <circle cx='15.5003' cy='14.1565' r='14.0198'
        fill='currentColor' />
      <path d='M14.2246 31.9998C14.2246 31.9998 23.996 26.4769 26.1202 23.0781L15.4991 28.1762L14.2246 31.9998Z' fill='currentColor' />
      <path fillRule='evenodd' clipRule='evenodd' d='M18.8597 9.48291C19.6279 9.48291 20.2501 10.1051 20.2501 10.8733V12.7309L23.3632 10.826C23.69 10.6258 24.1182 10.7287 24.3191 11.0554C24.3859 11.1653 24.4213 11.2904 24.4213 11.419V17.4061C24.4213 17.7898 24.1099 18.1013 23.7261 18.1013C23.6204 18.1013 23.5155 18.077 23.4202 18.0304L20.3335 16.5183L20.2501 16.4731V17.8253C20.2501 18.5935 19.6279 19.2157 18.8597 19.2157H10.5173C9.74916 19.2157 9.12695 18.5935 9.12695 17.8253V10.8733C9.12695 10.1051 9.74916 9.48291 10.5173 9.48291H18.8597Z'
        fill='white' />

    </Icon>
  );
}

export default styled(VideoChat)``;